// modules
import { createSelector } from 'reselect'

export const patients = (state) => state.patients

export const resentlyVievedPatients$ = createSelector(
  patients,
  ({ recentlyViewed }) => recentlyViewed
)
